import Animation from 'assets/dossier.json';
import Lottie from 'lottie-react';

const DossierAnimation = ({ className }: { className: string }) => {
  return <Lottie className={className} animationData={Animation} loop={true} />;
};

export default DossierAnimation;
